import Nav from './Nav';

const Header = () => {
    return (
        <div className= 'header'>
          <h1 id='myh1'>William's Portfolio</h1>
          <Nav/>
        </div>
    );
};
export default Header;